
export type ProjectDashboardFilterType = '' | 'FILTER_BY_STATUS' | 'OPEN_ITEMS';
export type ProjectFilterType = 'MARKET_QUOTE' | 'DRAFT' | 'IN_REVIEW' | 'BIDDING' | 'BID_REVIEW' | 'IN_DILIGENCE' | 'EXECUTED' | 'COMPLETED' | 'CLOSED';
export type ProjectFilterSourceType = 'TAB' | 'DROPDOWN';

export const ProjectDashboardFilters = {
  ALL: '',
  FILTER_BY_STATUS: 'FILTER_BY_STATUS',
  OPEN_ITEMS: 'OPEN_ITEMS',
};

export const ProjectDashboardFiltersList = [
  { value: ProjectDashboardFilters.ALL, label: 'All projects'},
  { value: ProjectDashboardFilters.FILTER_BY_STATUS, label: 'Filter by status'},
  { value: ProjectDashboardFilters.OPEN_ITEMS, label: 'Open items' },
];

export const ProjectFilterSource = {
  TAB: 'TAB' as ProjectFilterSourceType,
  DROPDOWN: 'DROPDOWN' as ProjectFilterSourceType,
};

export const ProjectStatusFilters = {
  MARKET_QUOTE: 'MARKET_QUOTE',
  NOT_SUBMITTED: 'NOT_SUBMITTED',
  IN_REVIEW: 'IN_REVIEW',
  BID_REVIEW: 'BID_REVIEW',
  BIDDING: 'BIDDING',
  IN_DILIGENCE: 'IN_DILIGENCE',
  EXECUTED: 'EXECUTED',
  COMPLETED: 'COMPLETED',
  CLOSED: 'CLOSED',
  CUSTOMER_PROPOSALS: 'CUSTOMER_PROPOSALS',
};

export const ProjectStatusFiltersList = [
  { value: ProjectStatusFilters.MARKET_QUOTE, label: 'Estimates', hideForInvestors: true },
  { value: ProjectStatusFilters.NOT_SUBMITTED, label: 'Draft', hideForInvestors: true },
  { value: ProjectStatusFilters.IN_REVIEW, label: 'In review', hideForInvestors: true },
  { value: ProjectStatusFilters.BIDDING, label: 'Bidding' },
  { value: ProjectStatusFilters.IN_DILIGENCE, label: 'In diligence' },
  { value: ProjectStatusFilters.EXECUTED, label: 'Executed' },
  { value: ProjectStatusFilters.COMPLETED, label: 'Completed'},
  { value: ProjectStatusFilters.CLOSED, label: 'Closed' },
];